import { makeStyles } from "@material-ui/core";
import { Chart, Tooltip, Axis, Legend, LineAdvance } from "bizcharts";
import { useSelector } from "react-redux";
import clsx from 'clsx';
import UtilService from "../../../../../../../helper/service";
import useWindowSize from '../../../../../../../helper/hooks/useWindowSize';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    overflow: 'hidden',
    scrollbarWidth: 'none',
    height: '600px',
    zIndex: 3,
  },
  graph: {
    position: 'absolute',
    opacity: 0.8
  },
  chart: {
    '& canvas': {
      height: '200px!important',
    }
  },
  chartBig: {
    '& canvas': {
      height: '506px!important',
    }
  },
  chartH1: {
    '& canvas': {
      height: '380px!important',
    }
  },
  chartH2: {
    '& canvas': {
      height: '300px!important',
    }
  },
  chartH3: {
    '& canvas': {
      height: '240px!important',
    }
  }
}));

function KnownOverviewLineBarGraph(props: any) {

  const classes = useStyles();
  const { clip, graphData, width, height, playPosition, marginTop, marginBottom, popOut, overview } = props;
  const { data } = graphData;
  const { analyseStart, analyseEnd, cliped, currentSession, stimulus, settings } = useSelector((state: any) => state.analysis);
  const { session_type } = currentSession;
  const { graphZoom } = settings;
  const winWidth = useWindowSize().width;
  const cHeight = (winWidth > 1500 ? 380 : winWidth > 1100 ? 300 : 240)

  const filterData = (data ? data : [])
    .map((item: any) => {
      return {
        value: item.immersion_index,
        timestamp: (session_type === 'ASYNC')
          ? (UtilService.getLocalEpoch2(item.time_stamp) - UtilService.getLocalEpoch2("1970-01-01 00:00:00"))
          : UtilService.getLocalEpoch2(item.time_stamp)
      }
    })

  const myData = filterData
    .reduce((prev: any[], c: any, index: number) => {
      if (index < data.length && index > 0) {
        const timeDiff = Math.abs(c.timestamp - filterData[index - 1].timestamp)
        if (timeDiff > 1) {
          for (let i = 1; i < timeDiff; i++) {
            prev.push({
              value: 0,
              timestamp: filterData[index - 1].timestamp + i
            })
          }
        }
      }
      prev.push(c)
      return prev
    }, [])
    .sort(function (a: any, b: any) {
      return a.timestamp - b.timestamp
    })

  const scale = {
    value: {
      min: 0,
      max: 105,
      nice: true,
    },
    timestamp: {
      min: cliped ? cliped.start_clip : (session_type === 'ASYNC' ? 0 : analyseStart),
      max: cliped ? cliped.end_clip : (session_type === 'ASYNC' ? stimulus?.stimulus_video_length : analyseEnd),
    },
  };

  return (
    <div id={'holder'}
      className={classes.root}
      style={{
        height: height,
        width: width,
        marginTop: marginTop ? marginTop : (clip ? 2 : 60),
        marginBottom: marginBottom ? marginBottom : 70
      }}
    >

      <div style={{ width: '100%', height: '100%', position: 'relative' }}>

        { !overview && <div id={'thing'} style={{ position: 'absolute', width: playPosition, height: (clip ? cHeight - 10 : 190), background: '#00000040', transition: '1.5s linear', }} />}

        <Chart
          className={clsx(classes.chartBig)}
          scale={scale}
          data={myData}
          animate={false}
          autoFit
          onClick={(ev: any) => {
            const xPos = ev.gEvent.x;
            const time = xPos * Math.pow(graphZoom, 2) / 15 + (cliped ? (session_type === 'ASYNC' ? cliped.start_clip : (cliped.start_clip - analyseStart)) : 0);
            if (popOut) {
              popOut(time);
            }
          }}
        >
          <Axis name="value" visible={false} />
          <Axis name="timestamp" visible={false} />
          <Legend visible={false} />
          <Tooltip visible={false} />

          <LineAdvance
            shape="smooth"
            area
            position="timestamp*value"
            color={'#fdca42'}
            size={5}
          />


          {/**<Area position="timestamp*value" color={'yellow'} animate={{
            enter: {
              duration: 1000,
            },
            leave: false,
          }} />*/}

        </Chart>
      </div>
    </div>
  );
}

export default KnownOverviewLineBarGraph;